import { modifier } from 'ember-modifier';

/** `<html>` class toggled while impersonating; pairs with `styles/apps/xceed-v2/impersonation-frame.scss`. */
export const IMPERSONATION_FRAME_CLASS = 'll-auth-is-impersonating';

/**
 * Syncs impersonation viewport frame styling on `<html>`.
 *
 * Import `@efdigital/ll-addon-auth/styles/impersonation-frame.scss` in the app
 * stylesheet, then attach this modifier on the application route template:
 *
 * ```gts
 * <div {{impersonationFrame this.session.cached.isImpersonating}}>...</div>
 * ```
 */
export const impersonationFrame = modifier<
  HTMLElement,
  [isImpersonating: boolean]
>((_element: HTMLElement, [isImpersonating]: [boolean]) => {
  const root = document.documentElement;

  root.classList.toggle(IMPERSONATION_FRAME_CLASS, isImpersonating);

  return () => {
    root.classList.remove(IMPERSONATION_FRAME_CLASS);
  };
});
